/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();
const DEFAULT_APP_CONFIG = storageService.get("appConfig", "session");

export const LANDING_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us"
    },
    {
        type: "dropdown",
        id: 'categories',
        name: "Categories",
        items: []
    },
    {
        type:"link",
        id:'mintpad',
        link:"/signup",
        name:"Are you a Asset Creator ?"
    },
    // {
    //     type: "link",
    //     link: "/#store",
    //     name: "Download Wallet"
    // },
    {
        type: "dropdown",
        id: 'more',
        name: "More",
        items: [
            {
                id:"contact",
                type: "link",
                link: "/#contact",
                name: "Contact"
            },
            // {
            //     id:"download",
            //     type:"link",
            //     link:"/#store",
            //     name: "Download Wallet"
            // },
            {
                id:"faq",
                type:"link",
                link:DEFAULT_APP_CONFIG?.organization?.faqURL,
                name:"FAQ's"
            }
        ]
    },
    // {
    //     id:"contact",
    //     type: "link",
    //     link: "/#contact",
    //     name: "Contact"
    // },
    {
        type:"avatar",
        iconType:"avatar",
        link:"/my-profile",
        avatar:"profile"
    },
    {
        type:"avatar",
        iconType:"avatar",
        link:"/my-wallet",
        avatar:"wallet"
    }
];


export const INNER_PAGES_NAV = [
    {
        type: "link",
        link: "/#about",
        name: "About Us"
    },
    {
        type: "dropdown",
        id: 'categories',
        name: "Categories",
        items: []
    },
    {
        type:"link",
        link:"",
        name:"Mintpad"
    },
    {
        type: "link",
        link: "/#contact",
        name: "Contact"
    },
    {
        type:"avatar",
        link:"/my-profile",
       // avatar:`${DEFAULT_APP_CONFIG?.servers?.rest?.imageServer}/imgbb/7KRdg5d/profile-vantr.png/:/rs=w:50`
        avatar:`https://i.ibb.co/7KRdg5d/profile-vantr.png`

    },
    {
        type:"avatar",
        link:"/my-wallet",
    //    avatar:`${DEFAULT_APP_CONFIG?.servers?.rest?.imageServer}/imgbb/6YQCyd3/wallet-blue.png/:/rs=w:50`
    avatar:`https://i.ibb.co/6YQCyd3/wallet-blue.png`

    }
]